import { MutableRefObject } from 'react';

import { useIsMobile } from './use-is-mobile';

const useAutocompleteScrollHandler = () => {
    const isMobile = useIsMobile();

    return (refWrapper: MutableRefObject<HTMLElement | null>) => () => {
        if (isMobile && refWrapper.current) {
            const scrollPosition = refWrapper.current.getBoundingClientRect().top + window.scrollY - 85; // height of nav;
            setTimeout(() => {
                // We add a slight delay to allow the mobile UI to adjust the viewport
                // without this delay, the scroll calculation can be inaccurate
                window.scrollTo({ top: scrollPosition });
            }, 100);
        }
    };
};

export { useAutocompleteScrollHandler };
